/*
 * Copyright (c) 2017-2026 Brighter AI Technologies GmbH. All rights reserved.
 * Unauthorized use, copying, reproduction, or distribution of this file, via any medium,
 * is strictly prohibited.
 */

import { Typography } from "@material-ui/core";

import React, { Suspense } from "react";

const Faq = React.lazy(async () => await import("./Faq.js"));
const Tutorials = React.lazy(async () => await import("./Tutorials.js"));
const Support = React.lazy(async () => await import("./Support.js"));

export const faqRoute = {
  path: "/faq",
  key: "faq",
  component: () => (
    <Suspense fallback={<Typography variant="body1">Loading...</Typography>}>
      <Faq />
    </Suspense>
  ),
};

export const contactRoute = {
  path: "/contact",
  key: "contact",
  component: () => (
    <Suspense fallback={<Typography variant="body1">Loading...</Typography>}>
      <Support />
    </Suspense>
  ),
};

export const tutorialsRoute = {
  path: "/tutorials",
  key: "tutorials",
  component: () => (
    <Suspense fallback={<Typography variant="body1">Loading...</Typography>}>
      <Tutorials />
    </Suspense>
  ),
};
